'use client';

import { motion, useInView } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

import Line from '@/components/Line';
import Testimonials from '@/components/Testimonials';

export default function ClientStories() {
  const [lineLength, setLineLength] = useState(80);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    const updateLineLength = () => setLineLength(window.innerWidth * 0.1);
    updateLineLength();
    window.addEventListener('resize', updateLineLength);
    return () => window.removeEventListener('resize', updateLineLength);
  }, []);

  return (
    <section className="text-center relative mt-8" ref={ref}>
      {isInView && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="mx-auto flex flex-col items-center">
            <Line
              direction="top"
              length={lineLength * 0.5}
              thickness={2}
              duration={1.2}
            />
            <div className="pt-16 flex justify-center items-center relative w-full">
              <div className="absolute left-0 top-1/2 transform -translate-y-1/2">
                <Line
                  direction="left"
                  length={lineLength * 2}
                  thickness={2}
                  duration={1.2}
                />
              </div>
              <div className="relative flex flex-col items-center">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-base-content">
                  Client
                </h2>
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-primary">
                  Stories
                </h2>
              </div>
              <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
                <Line
                  direction="right"
                  length={lineLength * 2}
                  thickness={2}
                  duration={1.2}
                />
              </div>
            </div>
            <div className="flex justify-between w-full px-8 mt-4">
              <p className="text-sm sm:text-lg md:text-lg lg:text-lg xl:text-xl font-normal text-base-content">
                <span className="text-primary">/</span> testimonials
              </p>
              <p className="text-sm sm:text-lg md:text-lg lg:text-lg xl:text-xl font-normal text-gray-600">
                Scroll to explore
              </p>
            </div>
          </div>
        </motion.div>
      )}
      <Testimonials
        testimonials={[
          {
            rating: 5,
            text: 'Great job on our logo and branding! It perfectly captures our brand’s vision, and we’re thrilled with the result!',
            reviewerName: 'Jivitesh Sharma',
            reviewerImage: '/images/jivi.avif',
            reviewerDesignation: 'Founder',
            company: 'Worklabs Pvt Ltd',
            companyLogo: '/images/worklabs.avif',
            background: '/images/testimonial0.avif',
          },
          {
            rating: 5,
            text: 'Fantastic work on our branding and app development! They perfectly brought our vision to life, and we couldn’t be happier with the results!',
            reviewerName: 'Shubham Batish',
            reviewerImage: '/images/shubham.avif',
            reviewerDesignation: 'CEO',
            company: 'The Titans Fitness',
            companyLogo: '/images/flex.avif',
            background: '/images/testimonial1.avif',
          },
        ]}
      />
    </section>
  );
}
